<template>
    <div class="hds-o-accordion">
        <button
            :id="id"
            type="button"
            class="hds-o-accordion__header d-flex justify-content-between align-items-center gap-16 text-midnight-800"
            :style="hasBanner ? 'scroll-margin-top: 11rem' : 'scroll-margin-top: 8rem'"
            :class="headerClass"
            @click="toggleAccordion">
            <slot name="accordion-header"/>
            <Icon
                v-if="showSlot"
                id="collapse-expand-accordion"
                name="far fa-chevron-up"
                size="1x"/>
            <Icon 
                v-else
                id="collapse-expand-accordion"
                name="far fa-chevron-down"
                size="1x"/>
        </button>

        <div v-show="showSlot" :class="{'accordion-grid-body': isGridLayout}">
            <slot name="accordion-body"/>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, watch} from 'vue';
import {Icon} from '@helcim/blizzard';

const props = defineProps({
    id: { type: String, required: true },
    headerClass: { type: String, default: '' },
    isOpen: { type: Boolean, default: true },
    hasBanner: { type: Boolean, default: false },
    isGridLayout: { type: Boolean, default: false },
});

const showSlot = ref(props.isOpen);

function toggleAccordion(): void {
    showSlot.value = !showSlot.value;
}

watch(() => props.isOpen, (value) => {
    showSlot.value = value;
});
</script>
